import * as React from "react";
import { Box } from "../box/box.component";
import { StyledOrder } from "./order.style";
import { Button } from "../button/button.component";
import { LabelContext } from "../../core/label.context";
import {createPrice, parsePrice} from "../../common/constants";
import { ProductInfo } from "../productInfo/productInfo.component";
import { Address } from "../elements/address/address.component";
import {BRX_BASE_URL, calls, IS_RETURNS_ACTIVE, PROJECT_CURRENCY, PROJECT_KEY} from "../../core/APIUtils"
import {RESTContext} from "../../core/rest.context";
import {ReturnCheckResult} from "../../common/common.models";

export const Order = (props: any) => {
  const { setActiveItem, activeItem, index, order, hideButton } = props;
  const { billingAddress, shippingAddress, lineItems, customLineItems } = order || {};
  const { t } = React.useContext(LabelContext);
  const { ajaxMiddleware$, token } = React.useContext(RESTContext)
  const [giftCardDetails, setGiftCardDetails] = React.useState([]);
  const [hasReturnableProducts, setHasReturnableProducts] = React.useState(false)

  const expanded = activeItem === index;
  const cls = "order__item " + (expanded ? "item-active" : "");

  // Recupero stato reso per l’ordine
  React.useEffect(() => {
    if(IS_RETURNS_ACTIVE){
      const body = {
        orderNumber: order.orderNumber,
        projectKey: PROJECT_KEY,
        authToken: token?.access_token
      }

      ajaxMiddleware$(calls.Project.returnStatus(), undefined, body).subscribe({
        next: (res: ReturnCheckResult) => setHasReturnableProducts(res.hasReturnableProducts),
        error: (err) => console.error("Errore returnStatus:", err.message),
      })
    }
  }, [order.orderNumber])

  let orderDate, orderState;
  if (order) {
    orderDate = new Date(order?.createdAt)
    // Open
    orderState = t('ecommerce.orders.state-confirmed')
    if (order?.shipmentState === "Shipped") {
      // Spedito
      orderState = t('ecommerce.orders.state-shippied')
    }
    if (order?.orderState === "Complete") {
      // Spedito
      orderState = t('ecommerce.orders.state-completed')
    }
    if (order?.orderState === "Cancelled") {
      // Spedito
      orderState = t('ecommerce.orders.state-cancelled')
    }

    //order?.orderState
    // Confermato
    // Annullato
    // Completato
  }

  let productsList = lineItems.filter((p: any) => p.productType.obj?.key !== "services")
  let servicesList = lineItems.filter((s: any) => s.productType.obj?.key === "services")

  React.useEffect(()=> {
    const giftCardDetails = customLineItems
        .filter((c: any) => c.slug && c.slug.startsWith("gift-card"))
        .map((item: any) => {
          const amount = Math.abs(item.money.centAmount);
          const serialNumber = item.slug.split("gift-card-")[1];
          return {
            amount: amount,
            serialNumber: serialNumber
          };
        });
    setGiftCardDetails(giftCardDetails)
  },[])



  return (
    <StyledOrder className="cmp_order">
      <Box className={`secondary ${cls}`}>
        <div className={`row ${cls} align-items-stretch`}>
          <div className="col-md-10">
            <div className="item__head">
              <div>{t("ecommerce.orders.order")} {t("ecommerce.orders.number")}<b>{order?.orderNumber} - {orderState}</b></div>
              <div>{t("ecommerce.orders.orderDate")}: {orderDate?.toLocaleDateString()}</div>
              <div>{t("ecommerce.orders.orderAmount")}: {parsePrice(order?.totalPrice)}</div>
              {giftCardDetails && giftCardDetails.length > 0 &&
                giftCardDetails.map((giftcard: any) => (
                    <div>{t("ecommerce.orders.giftcardAmount")}: {parsePrice(createPrice(giftcard.amount, PROJECT_CURRENCY))} ({t("ecommerce.orders.giftcardSerial")} : {giftcard.serialNumber})</div>
                ))
              }
            </div>
          </div>
          {!hideButton && (
            <div className="col-md-2">
              <Button
                  className="secondary"
                  label={expanded ? t('ecommerce.orders.btn-hide-details') : t('ecommerce.orders.btn-show-details')}
                  onClick={() => index === activeItem ? setActiveItem(null) : setActiveItem(index)}
              />
              {IS_RETURNS_ACTIVE &&
                  <Button
                    className="primary"
                    label={t("ecommerce.my-orders.create-return")}
                    onClick={() => {
                      window.location.href = `${BRX_BASE_URL}/return?orderId=${order.id}`
                    }}
                    btn_disabled={!hasReturnableProducts}
                  />
              }
            </div>
          )}
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="item__body">
              <div className="shippingAddress">
                <br />
                <h4>{t("ecommerce.orders.shippingAddress")}:</h4>
                <Address compact={true} item={shippingAddress}/>
              </div>
              <p/>
              <div className="paymentMethod">
                <br />
                <h4>{t("ecommerce.orders.billingAddress")}:</h4>
                <Address compact={true} item={billingAddress}/>
              </div>


              <p/>
              <div className="items">
                <br />
                <h4>{t("ecommerce.orders.products")}</h4>
                <div className="col-lg-6 col-xl-8">
                  {productsList?.map((item: any) => {
                    return (
                      <Box className="secondary" key={item.id}>
                        <ProductInfo item={item} services={servicesList} callerComponent={"myorders"}/>
                      </Box>
                    )
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Box>
    </StyledOrder >
  );
};
